<template>
    <div id='results'>
        <div class='container' :style="contentHeight">
            <h3> <fa-icon icon="chevron-left" @click="showPreviousPage" /> The votes so far</h3>
            <div class='row'>
                <div class='col-md-6'>
                    <b>Food</b>
                    <br><br>
                    <div>
                        <ResultItem 
                            v-for="food in foods"
                            :key="food.id"
                            :text="food.text"
                            :value="food.votes"
                            :total="foodTotal"
                            :max="foodMax"
                            :animate="animateFood"
                            />
                    </div>
                </div>

                <div class='col-md-6 places'>
                    <b>Places</b>
                    <br><br>
                    <div>
                        <ResultItem 
                            v-for="place in places"
                            :key="place.id"
                            :text="place.text"
                            :value="place.votes"
                            :total="placeTotal"
                            :max="placeMax"
                            :animate="animatePlace"
                            />
                    </div>
                </div>
            </div>
        </div>

        <!-- ACTION BAR -->
        <div class='action-bar'>
            <div class='container d-flex align-items-center'>
                <img src="/icons/down.png" @click="submit">
                <p>Almost there ...</p>
            </div>
        </div>
    </div>
</template>

<script>

import ResultItem from "../widgets/ResultItem";
import http from "../../lib/http.ts"
import { setTimeout } from 'timers';

export default {
    name: 'results',
    components: {ResultItem},
    props: {
        pollFood: {required: true},
        pollPlace: {required: true},
        height: {required: true}
    }, 

    data() {
        return {
            foodTotal: 0,
            foodMax: 0,
            placeTotal: 0,
            placeMax: 0,
            foods: [],
            places: [],
            animateFood: false,
            animatePlace: false,

            contentHeight: {height: this.height, overflow: "auto", paddingBottom: "160px"}
        }
    },

    methods: {
        submit () {
            this.$emit('show-page', 'next-location')
        },

        showPreviousPage() {
            this.$emit('show-page', 'place');
        },

        fetch(){

            http().get(`/polls/${this.pollFood.id}/results`).then(r => {
                this.foods = r.data.results
                this.foodTotal = r.data.total
                this.foodMax = r.data.max
                setTimeout(() => {this.animateFood = true}, 500);
            });

            http().get(`/polls/${this.pollPlace.id}/results`).then(r => {
                this.places = r.data.results;
                this.placeTotal = r.data.total;
                this.placeMax = r.data.max;
                setTimeout(() => {this.animatePlace = true}, 500);
            })
        },
    }
}
</script>

<style lang="scss" scoped>
    h3 {margin-bottom: 20px}
    #results {
        position: relative;
        .container {padding-top: 40px}

        .action-bar {
            z-index: 1000; 
            position: absolute; 
            bottom: 0; left: 0; 
            width: 100%; 
            background-color: white;
            padding-bottom: 20px;
            
            .container {padding-top: 20px}
            IMG {height: 80px; cursor: pointer;}
            P {margin: 0 0 0 10px}
        }
    }

    @media (max-width: 767.98px) { 
        #results  {
            .container {
                padding-top: 20px;
            }

            .places {margin-top: 20px}

            .action-bar { 
                padding-top: 0px;
                padding-bottom: 10px;
                IMG {height: 60px} 
                .container {padding-top: 10px}
            }   
        }
        
    }
</style>